var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("商品品牌")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("添加品牌")]),
        _c(
          "el-form",
          {
            staticClass: "demo-form-inline",
            attrs: { inline: true, model: _vm.formInline },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "产品品牌" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "125", placeholder: "请输入添加品牌" },
                  model: {
                    value: _vm.formInline.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInline, "name", $$v)
                    },
                    expression: "formInline.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "英文名" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "125", placeholder: "请输入添加品牌" },
                  model: {
                    value: _vm.formInline.ename,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInline, "ename", $$v)
                    },
                    expression: "formInline.ename",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _vm.parArray.indexOf("addBrand") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit },
                      },
                      [_vm._v("添加品牌")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "manage" }, [
      _c("p", { staticClass: "header" }, [_vm._v("管理品牌")]),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData.list } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号" },
              }),
              _c("el-table-column", {
                attrs: { scope: "scope", label: "品牌名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { maxlength: "125" },
                          model: {
                            value: scope.row.name,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "name", $$v)
                            },
                            expression: "scope.row.name",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { scope: "scope", label: "品牌英文名" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { maxlength: "125" },
                          model: {
                            value: scope.row.fenName,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "fenName", $$v)
                            },
                            expression: "scope.row.fenName",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "更新时间", prop: "createdTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "optain" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "保存",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("brandbc") != -1
                                  ? _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.preservation(scope.row)
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("保存")])]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "删除",
                                  placement: "top-start",
                                },
                              },
                              [
                                _vm.parArray.indexOf("brandDelect") != -1
                                  ? _c(
                                      "p",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.delect(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("删除")])]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.tableData.totalNum >= 7
            ? _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("span", { staticClass: "demonstration" }, [
                      _vm._v("共" + _vm._s(_vm.tableData.totalPage) + "页"),
                    ]),
                    _c("span", { staticClass: "demonstration" }, [
                      _vm._v("总共" + _vm._s(_vm.tableData.totalNum) + "条"),
                    ]),
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.currentPage1,
                        "page-size": 1,
                        layout: "prev, pager, next",
                        "prev-text": "上一页",
                        "next-text": "下一页",
                        total: _vm.tableData.totalPage,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "update:currentPage": function ($event) {
                          _vm.currentPage1 = $event
                        },
                        "update:current-page": function ($event) {
                          _vm.currentPage1 = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }